// eslint-disable-next-line import/no-named-as-default
// import { AxiosDefaults } from 'axios';
import getClient, { ClientAxiosInstance } from './config';

const client: ClientAxiosInstance = {
  // defaults: (configuration: AxiosDefaults): getClient(configuration).headers
  get: (url, configuration) => getClient(configuration).get(url, configuration),
  post: (url, data, configuration) =>
    getClient(configuration).post(url, data, configuration),
  put: (url, data, configuration) =>
    getClient(configuration).put(url, data, configuration),
  delete: (url, configuration) =>
    getClient(configuration).delete(url, configuration),
  patch: (url, data, configuration) =>
    getClient(configuration).patch(url, data, configuration),
};

export default client;
